import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { TabList, TabPanel } from "@similarweb/ui-components";

export const TabListStyled = styled(TabList)`
    border-bottom: 0;
    padding-left: 24px;
    z-index: 1;
    .disabled {
        [data-automation="badge"] {
            background: ${colorsPalettes.carbon["200"]} !important;
        }
    }
`;

export const TabsContainer = styled.div`
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0px 4px 6px 0px rgba(202, 202, 202, 0.5);
    z-index: 9;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
    position: sticky;
    top: 0;
`;

export const ContentContainer = styled.div`
    flex-grow: 1;
    display: flex;
    padding: 24px 0px;
    justify-content: center;
    background-color: ${colorsPalettes.bluegrey["100"]};
    ${TabPanel} {
        margin: 0 auto;
    }
    .react-tabs {
        width: 100%;
    }
`;
